import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit';

import {
  NullableString,
  NullableStringArray
} from '../../interfaces';
import { RootState } from '../../store';

export interface UserBusinessProps {
  userBusiness: NullableStringArray;
  currentBusinessId: NullableString;
  currentWorkflow: NullableString;
  isLoading: boolean;
  errorMessage: string | null;
}

const initialState: UserBusinessProps = {
  userBusiness: null,
  currentBusinessId: null,
  currentWorkflow: null,
  isLoading: true,
  errorMessage: null
}

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    setRFXUserBusiness(state, action: PayloadAction<NullableStringArray>) {
      console.log(`Set user business in businessSlice with value: ${JSON.stringify(action.payload)}`);
      state.userBusiness = action.payload;
    },
    setIsGetRFXUserBusinessLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setCurrentBusinessId(state, action: PayloadAction<string>) {
      state.currentBusinessId = action.payload;
    },
    setCurrentWorkflow(state, action: PayloadAction<NullableString>) {
      state.currentWorkflow = action.payload;
    }
  },
});

export const {
  setRFXUserBusiness,
  setIsGetRFXUserBusinessLoading,
  setCurrentBusinessId,
  setCurrentWorkflow
} = businessSlice.actions;

export const selectRFXUserBusiness = (state: RootState): NullableStringArray => {
  return state.business.userBusiness;
}

export const selectIsGetRFXUserBusinessLoading = (state: RootState) => {
  return state.business.isLoading;
}

export const selectCurrentBusinessId = (state: RootState) => {
  return state.business.currentBusinessId;
}

export const selectCurrentWorkflow = (state: RootState) => {
  return state.business.currentWorkflow;
}

export default businessSlice.reducer;
